module.exports = __webpack_public_path__ + "img/introduce_furniture.394c40db.jpg";